module.exports = __webpack_public_path__ + "static/media/blockchain4.1442511a.svg";